import React from "react";
import { FaTerminal, FaWifi, FaBatteryFull, FaNpm } from "react-icons/fa";

export const PhoneMockup = ({ project }) => {
  return (
    <div className="device-phone-wrapper">
      <div className="iphone-frame">
        {/* Dynamic Island */}
        <div className="iphone-dynamic-island">
          <div className="island-camera"></div>
          <div className="island-sensor"></div>
        </div>

        {/* Status Bar */}
        <div className="iphone-status-bar">
          <span className="status-time">9:41</span>
          <div className="status-icons">
            <FaWifi className="status-icon" />
            <FaBatteryFull className="status-icon" />
          </div>
        </div>

        {/* Screen Content */}
        <div className="iphone-screen">
          {project.image ? (
            <div className="phone-img-container">
              <img
                src={project.image}
                alt={project.title}
                className="phone-screen-img"
                loading="lazy"
              />
            </div>
          ) : (
            <div className="phone-screen-placeholder">
              <div className="placeholder-badge">{project.badge || "Live App"}</div>
              <h4>{project.title}</h4>
              <p>{project.subtitle}</p>
            </div>
          )}
        </div>

        {/* Home Indicator */}
        <div className="iphone-home-indicator"></div>
      </div>
    </div>
  );
};

export const BrowserMockup = ({ project }) => {
  return (
    <div className="browser-mockup-wrapper">
      <div className="browser-frame">
        {/* Browser Topbar */}
        <div className="browser-header">
          <div className="browser-traffic-lights">
            <span className="dot red"></span>
            <span className="dot yellow"></span>
            <span className="dot green"></span>
          </div>
          <div className="browser-url-bar">
            <span className="lock-icon">🔒</span>
            <span className="url-text">
              {project.id === "bcrypty"
                ? "https://bcrypty.web3.network/app"
                : "https://batchbrain.com"}
            </span>
          </div>
        </div>

        {/* Browser Screen Content */}
        <div className="browser-content">
          {project.image ? (
            <div className="browser-img-container">
              <img
                src={project.image}
                alt={project.title}
                className="browser-screen-img"
                loading="lazy"
              />
            </div>
          ) : (
            <div className="browser-placeholder-body">
              <h3>{project.title}</h3>
              <p>{project.subtitle}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const CodePackageMockup = ({ project }) => {
  return (
    <div className="code-mockup-wrapper">
      <div className="code-frame">
        <div className="code-header">
          <div className="browser-traffic-lights">
            <span className="dot red"></span>
            <span className="dot yellow"></span>
            <span className="dot green"></span>
          </div>
          <div className="code-tab-title">
            <FaNpm className="npm-icon" /> react-env-secrets.ts
          </div>
          <div className="code-badge">v1.2.0 • TypeScript</div>
        </div>
        <div className="code-body">
          <div className="npm-install-bar">
            <span className="prompt">$</span> npm install react-env-secrets
          </div>
          <pre className="code-snippet">{`import { createEnv } from 'react-env-secrets';
import { z } from 'zod';

export const env = createEnv({
  server: {
    DATABASE_URL: z.string().url(),
    API_SECRET_KEY: z.string().min(32),
  },
  client: {
    NEXT_PUBLIC_APP_URL: z.string().url(),
  },
  runtimeEnv: process.env,
  cache: true, // In-memory cached access
});`}</pre>
        </div>
      </div>
    </div>
  );
};

export const TerminalMockup = ({ project }) => {
  return (
    <div className="terminal-mockup-wrapper">
      <div className="terminal-frame">
        <div className="terminal-header">
          <div className="browser-traffic-lights">
            <span className="dot red"></span>
            <span className="dot yellow"></span>
            <span className="dot green"></span>
          </div>
          <div className="terminal-title">
            <FaTerminal /> deviddy-api-cluster ~ production
          </div>
          <div className="terminal-badge">200 OK • 18ms</div>
        </div>
        <div className="terminal-body">
          <p className="cmd-line">
            <span className="prompt">$</span> curl -X POST https://api.deviddy.com/v1/feed/trending \
          </p>
          <p className="cmd-line indent">
            -H "Authorization: Bearer eyJhbGciOiJIUzI1NiIsIn..." \
          </p>
          <p className="cmd-line indent">-H "Content-Type: application/json"</p>
          <div className="json-response">
            <span className="comment">
              {"// Response (200 OK • Latency: 18ms • Cache: HIT)"}
            </span>
            <pre>{`{
  "status": "success",
  "data": {
    "feed": [
      {
        "id": "vid_904128",
        "title": "React Native Performance Optimization",
        "creator": "@rayyan_dev",
        "views": 142800,
        "likes": 18240,
        "videoStreamUrl": "https://cdn.deviddy.com/streams/rn_opt.m3u8",
        "verified": true
      }
    ],
    "pagination": { "nextCursor": "cur_8921a", "hasMore": true }
  },
  "metrics": { "dbQueryMs": 4.2, "cacheHit": true, "cluster": "us-east-1a" }
}`}</pre>
          </div>
        </div>
      </div>
    </div>
  );
};
